export default {
  state: {
    gsa: {}
  },
  mutations: {
    set_gsa(state, value) {
      state.gsa = value
      
    },
    update_gsa(state, gsa) {
      state.gsa = state.gsa.map( el => {
        return el.id == gsa.id ? gsa : el
      })
    },
    append_gsa(state, gsa) {
      state.gsa = [...state.gsa, gsa]
    }
  },
  actions: {
    async load_gsa_list({dispatch, commit}) {
      let r = await dispatch('api_request', {endpoint: '/gsa'})
      commit('set_gsa', r)
    },
    async create_token({ dispatch }, guid) {
      return await dispatch('api_request', {endpoint: `/gsa/create_token?agent_guid=${guid}`})
    },
    async delete_gsa({ dispatch, commit }, id) {
      let r = await dispatch('api_request', {endpoint: `/gsa/delete?agent_id=${id}`})
      commit('update_gsa', r)
    },
    async restore_gsa({ dispatch, commit }, id) {
      let r = await dispatch('api_request', {endpoint: `/gsa/restore?agent_id=${id}`})
      commit('update_gsa', r)
    },
    async load_gsa_by_object({dispatch}, object_id) {
      return await dispatch('api_request', {endpoint: `/gsa?object_id=${object_id}`})
    },
    async create_gsa({ dispatch, commit }, gsa) {
      let r = await dispatch('api_request', {endpoint: '/gsa/create', body: gsa})
      await commit('append_gsa', r)
      return r
    },
    async update_gsa({ dispatch, commit }, gsa) {
      let r = await dispatch('api_request', {endpoint: '/gsa/update', body: gsa})
      await commit('update_gsa', r)
      return r
    },
    async get_gsa_config({ dispatch }, agent_guid) {
      return await dispatch('api_request', {endpoint: `/gsa/config?agent_guid=${agent_guid}`})
    },
    async update_gsa_config({ dispatch }, { agent_guid, payload }) {
      return await dispatch('api_request', {endpoint: `/gsa/config?agent_guid=${agent_guid}`, body: payload})
    },
  },
  getters: {
    gsa_map(state) {
      let map = {}
      
      for (let item of state.gsa) {
        map[item.id] = item
      }
      return map
    },
    gsa(_, getters){
      return (gsa_id) => {
        return getters.gsa_map[gsa_id]
      }
    },
    all_gsa(state){
      return state.gsa
    }
  }
}